import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';

@Component({
  selector: 'app-member-profile-roles',
  templateUrl: './member-profile-roles.component.html',
  styleUrls: ['./member-profile-roles.component.scss'],
})
export class MemberProfileRolesComponent implements OnInit {
  public membersType: Array<any> = [];
  public imgUrl = environment.ImageUrl;
  public itemAboutToBuy: any = null;
  public modelRef: any = null;
  carouselOptions: any = {
    slidesPerView: 3,
  };
  constructor(
    private auth: AuthServiceService,
    private sharedService: SharedService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    public roleService: RoleService
  ) {}

  ngOnInit(): void {
    this._userTypeList();
  }

  private _userTypeList(): void {
    this.auth.getDefaultUserTypeRoles().subscribe((response: ApiResponse) => {
      this.membersType = response?.body || [];
    });
  }

  GoToMyTabs(index: any = 1) {
    this.sharedService.triggerSelectMyTab(index);
  }

  public buy(selected: any, modal): void {
    this.modelRef ? this.modelRef.close() : '';
    this.itemAboutToBuy = selected;
    this.modelRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'role-buy',
    });
  }

  public buyRole(): void {
    this.auth
      .buyRoleForMember({ userTypeId: this.itemAboutToBuy.userTypeId })
      .subscribe(
        (resp: ApiResponse) => {
          this.toastr.success(resp.message);
          this.itemAboutToBuy = null;
          this.modelRef.close();
          this._userTypeList();
          //this.roleService.getAllRoles();
        },
        ({ error }) => {
          this.toastr.error(error.message);
        }
      );
  }

  public disableEnableRole(userUserTypeId, status) {
    this.auth
      .updateStatusOfMemberToUserTypes({
        userUserTypeId: userUserTypeId,
        status: status == 1 ? 0 : 1,
      })
      .subscribe(
        (resp: ApiResponse) => {
          this.toastr.success(resp.message);
          this._userTypeList();
          //this.roleService.getAllRoles();
        },
        ({ error }) => {
          this.toastr.error(error.message);
        }
      );
  }

  public openInfo(modal, selected: any) {
    this.modelRef ? this.modelRef.close() : '';
    this.itemAboutToBuy = selected;
    this.modelRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'role-info',
    });
  }
}
